/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { injectIntl } from 'react-intl'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import Card from '@/checkout-instore-legacy/components/Commons/Elements/Card'
import Loader from '@/checkout-instore-legacy/components/Commons/Loader'

import OrderTable from './OrderTable'

class OrderTableCard extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      orderId: '',
      orders: null,
      loading: true,
      startCursor: null,
      endCursor: null,
    }
  }

  onOrdersPageLoad = (startCursor, endCursor, perPage, searchTerm) => {
    this.setState({ loading: true })
    this.props
      .handlePageLoad({
        startCursor,
        endCursor,
        query: searchTerm,
        perPage,
      })
      .then((orders) => {
        this.setState({
          orders: orders.list,
          ordersLength: orders.totalCount,
          loading: false,
          endCursor: orders.pageInfo.endCursor,
          startCursor: orders.pageInfo.startCursor,
        })
      })
  }

  componentDidMount() {
    this.onOrdersPageLoad()
  }

  render() {
    const { orders, loading, ordersLength, startCursor, endCursor } = this.state

    return (
      <React.Fragment>
        {!orders && <Loader loading={loading} />}
        {orders && (
          <Card className="overflow-auto pt7-ns br-0">
            <div className="dn db-ns">
              <div className="flex flex-column justify-center ph7 pb7">
                <OrderTable
                  orders={orders}
                  ordersLoading={loading}
                  ordersLength={ordersLength}
                  startCursor={startCursor}
                  endCursor={endCursor}
                  handlePageLoad={this.onOrdersPageLoad}
                  handleOrderClick={(orderId) =>
                    this.props.handleOrderClick(orderId)
                  }
                />
              </div>
            </div>
          </Card>
        )}
      </React.Fragment>
    )
  }
}

OrderTableCard.propTypes = {
  router: PropTypes.object,
  handlePageLoad: PropTypes.func.isRequired,
  handleOrderClick: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
}

export default injectIntl(withRouter(OrderTableCard))
